import ApiService from "./ApiService"

export default {
    search(search) {
        let params = new URLSearchParams();
        if(search.output)
            params.append('output', search.output);
        if(search.search && search.search.length > 0)
            params.append('term', search.search);
        let qs = params.toString();
        if(qs && qs.length > 0)
            qs = "?" + qs;
        return ApiService().get(`api/companies/${search.offset}/${search.limit}${qs}`);
    },
    get(id) {
        return ApiService().get(`api/companies/${id}`);
    },
    put(id, company) {
        return ApiService().put(`api/companies/${id}`, company);
    },
    post(company) {
        return ApiService().post(`api/companies`, company);
    },
    delete(id) {
        return ApiService().delete(`api/companies/${id}`, { companyId: id});
    }
}